module.exports = __webpack_public_path__ + "1.4.15-unryo/img/ms-iis.c9e35a8d.png";